import { Box, Button, FormControl, Grid, TextField, Typography } from '@mui/material'
import React from 'react'
import { ArrowLeftCircle, ArrowRightCircle, Save } from 'react-feather'
import { ModalAdvanceTable } from './ModalAdvanceTable'

export const ModalAdvance = ({ useFetchInit, dataModal }) => {

  const {
    globalStates,
    Actions,
    defaultData,
    Forms
  } = useFetchInit

  const { dataRequest: { idexpense } } = dataModal


  const { FormAdvance: { formState, onInputChange, onInputChangeForNumber } } = Forms

  const { modalOpeningMode } = globalStates

  const { handleClickCloseModal, onSubmitFormAdvance } = Actions

  return (
    <>
      <form onSubmit={(e) => onSubmitFormAdvance(e, idexpense)}>
        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <FormControl fullWidth>
              <label htmlFor="advance">* Anticipo</label>
              <TextField
                id='advance'
                name='advance'
                value={formState.advance}
                onChange={onInputChangeForNumber}
                size='small'
                placeholder='Anticipo'
                hiddenLabel
                type='text'
                variant={(modalOpeningMode === 'READONLY') ? 'filled' : 'outlined'}
                InputProps={{
                  readOnly: (modalOpeningMode === 'READONLY') ? true : false
                }}
                required
              />
            </FormControl>
          </Grid>
        </Grid>
        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <FormControl fullWidth>
              <label htmlFor="description">Descripcion</label>
              <TextField
                id='description'
                name='description'
                value={formState.description}
                onChange={onInputChange}
                size='small'
                placeholder='Descripcion'
                type='text'
                multiline
                rows={4}
                variant='outlined'
              />
              <Typography
                variant="caption"
                align="right"
                color={formState.description.length >= 500 ? 'error' : 'textSecondary'}
              >
                {formState.description.length} / 500
              </Typography>
            </FormControl>
          </Grid>
        </Grid>

        <Grid container justifyContent="center" alignItems="center" style={{ height: '10%' }}>
          <Grid item xs={12}>
            <div className="text-center">
              {(modalOpeningMode === 'EDITABLE') && (
                <Button
                  endIcon={<Save />}
                  variant="contained"
                  type="submit"
                  className='btn-round'
                  color='primary'
                  sx={{ marginRight: 1, marginLeft: 1, marginTop: 2 }}
                >
                  {(formState.idexpense > 0) ? 'Actualizar' : 'Guardar'}
                </Button>
              )}
            </div>
          </Grid>
        </Grid>
      </form>

      <Box marginTop={4}>
        <ModalAdvanceTable useFetchInit={useFetchInit} dataModal={dataModal} />
      </Box>

      <Box marginTop={2} alignContent={'center'}>
        <div className="text-center">
          <Button
            startIcon={<ArrowLeftCircle />}
            variant="contained"
            type="button"
            className='btn-round'
            color='warning'
            onClick={() => handleClickCloseModal(false, 'EDIT')}
            sx={{ marginRight: 1, marginLeft: 1, marginTop: 3 }}
          >
            Volver
          </Button>
        </div>
      </Box>

    </>
  )
}
